"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadOnlySlots = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styles = require("../../styles");
const propTypes = {
  slotsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    time: _propTypes.string.isRequired
  })).isRequired
};
const ReadOnlySlots = _ref => {
  let {
    slotsData
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ReadOnlySlotList, null, (0, _map.default)(slotsData).call(slotsData, _ref2 => {
    let {
      date,
      time
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `${date}-${time}`
    }, `${date} at ${time}`);
  }));
};
exports.ReadOnlySlots = ReadOnlySlots;
ReadOnlySlots.propTypes = propTypes;
ReadOnlySlots.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ReadOnlySlots",
  "props": {
    "slotsData": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "date": {
              "name": "string",
              "required": true
            },
            "time": {
              "name": "string",
              "required": true
            }
          }
        }
      },
      "required": true
    }
  }
};